/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as PortalTributarioRouteImport } from './routes/portal.tributario'
import { Route as PortalOficinaVirtualRouteImport } from './routes/portal.oficina-virtual'
import { Route as PortalLoginRouteImport } from './routes/portal.login'
import { Route as PortalFacturasRouteImport } from './routes/portal.facturas'
import { Route as PortalDashboardRouteImport } from './routes/portal.dashboard'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppRrhhRouteRouteImport } from './routes/_app/rrhh/route'
import { Route as AppRemuneracionesRouteRouteImport } from './routes/_app/remuneraciones/route'
import { Route as AppF29RouteRouteImport } from './routes/_app/f29/route'
import { Route as AppControlRouteRouteImport } from './routes/_app/control/route'
import { Route as AppComplianceRouteRouteImport } from './routes/_app/compliance/route'
import { Route as AppClientsRouteRouteImport } from './routes/_app/clients/route'
import { Route as AppVirtualOfficesIndexRouteImport } from './routes/_app/virtual-offices/index'
import { Route as AppTasksIndexRouteImport } from './routes/_app/tasks/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppRrhhIndexRouteImport } from './routes/_app/rrhh/index'
import { Route as AppRemuneracionesIndexRouteImport } from './routes/_app/remuneraciones/index'
import { Route as AppProduccionIndexRouteImport } from './routes/_app/produccion/index'
import { Route as AppMessagingIndexRouteImport } from './routes/_app/messaging/index'
import { Route as AppInformesIndexRouteImport } from './routes/_app/informes/index'
import { Route as AppGestionesIndexRouteImport } from './routes/_app/gestiones/index'
import { Route as AppFacturacionIndexRouteImport } from './routes/_app/facturacion/index'
import { Route as AppF29IndexRouteImport } from './routes/_app/f29/index'
import { Route as AppEquipoIndexRouteImport } from './routes/_app/equipo/index'
import { Route as AppDiagnosticoTributarioIndexRouteImport } from './routes/_app/diagnostico-tributario/index'
import { Route as AppCorreoIndexRouteImport } from './routes/_app/correo/index'
import { Route as AppControlIndexRouteImport } from './routes/_app/control/index'
import { Route as AppContratosIndexRouteImport } from './routes/_app/contratos/index'
import { Route as AppComplianceIndexRouteImport } from './routes/_app/compliance/index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppCaptacionIndexRouteImport } from './routes/_app/captacion/index'
import { Route as AppApprovalsIndexRouteImport } from './routes/_app/approvals/index'
import { Route as AuthMfaEnrollRouteImport } from './routes/auth.mfa.enroll'
import { Route as AuthMfaChallengeRouteImport } from './routes/auth.mfa.challenge'
import { Route as AppVirtualOfficesSucursalesRouteImport } from './routes/_app/virtual-offices/sucursales'
import { Route as AppVirtualOfficesCorrespondenciaRouteImport } from './routes/_app/virtual-offices/correspondencia'
import { Route as AppVirtualOfficesAutorizacionesRouteImport } from './routes/_app/virtual-offices/autorizaciones'
import { Route as AppTasksBitacoraRouteImport } from './routes/_app/tasks/bitacora'
import { Route as AppSettingsWhatsappRouteImport } from './routes/_app/settings/whatsapp'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/settings/team'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppSettingsOvSedesRouteImport } from './routes/_app/settings/ov-sedes'
import { Route as AppSettingsOrganizationRouteImport } from './routes/_app/settings/organization'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsLostReasonsRouteImport } from './routes/_app/settings/lost-reasons'
import { Route as AppSettingsLaborParamsRouteImport } from './routes/_app/settings/labor-params'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations'
import { Route as AppSettingsChannelsRouteImport } from './routes/_app/settings/channels'
import { Route as AppSettingsCampaignsRouteImport } from './routes/_app/settings/campaigns'
import { Route as AppSettingsCampaignLinksRouteImport } from './routes/_app/settings/campaign-links'
import { Route as AppSettingsCamilaRouteImport } from './routes/_app/settings/camila'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppSettingsAccountRouteImport } from './routes/_app/settings/account'
import { Route as AppRrhhClientIdRouteImport } from './routes/_app/rrhh/$clientId'
import { Route as AppRemuneracionesPreviredRouteImport } from './routes/_app/remuneraciones/previred'
import { Route as AppInformesDestinatariosRouteImport } from './routes/_app/informes/destinatarios'
import { Route as AppF29TemplatesRouteImport } from './routes/_app/f29/templates'
import { Route as AppF29LeerRouteImport } from './routes/_app/f29/leer'
import { Route as AppF29ColaRouteImport } from './routes/_app/f29/cola'
import { Route as AppDebugSimulateRouteImport } from './routes/_app/debug/simulate'
import { Route as AppCorreoAuditDescarteRouteImport } from './routes/_app/correo/audit-descarte'
import { Route as AppComplianceRatRouteImport } from './routes/_app/compliance/rat'
import { Route as AppComplianceIncidentesRouteImport } from './routes/_app/compliance/incidentes'
import { Route as AppComplianceEventosRouteImport } from './routes/_app/compliance/eventos'
import { Route as AppComplianceContratosRouteImport } from './routes/_app/compliance/contratos'
import { Route as AppComplianceConsentimientosRouteImport } from './routes/_app/compliance/consentimientos'
import { Route as AppComplianceAuditoriaRouteImport } from './routes/_app/compliance/auditoria'
import { Route as AppComplianceArcoRouteImport } from './routes/_app/compliance/arco'
import { Route as AppClientsEstadoRouteImport } from './routes/_app/clients/estado'
import { Route as AppClientsBajasRouteImport } from './routes/_app/clients/bajas'
import { Route as AppClientsArchivoRouteImport } from './routes/_app/clients/archivo'
import { Route as AppMessagingLogsIndexRouteImport } from './routes/_app/messaging/logs/index'
import { Route as AppMessagingCampaignsIndexRouteImport } from './routes/_app/messaging/campaigns/index'
import { Route as AppCrmLeadsIndexRouteImport } from './routes/_app/crm/leads/index'
import { Route as AppCrmCatalogIndexRouteImport } from './routes/_app/crm/catalog/index'
import { Route as AppCrmAiActionsIndexRouteImport } from './routes/_app/crm/ai-actions/index'
import { Route as AppCorreoLogsIndexRouteImport } from './routes/_app/correo/logs/index'
import { Route as AppCorreoCampaignsIndexRouteImport } from './routes/_app/correo/campaigns/index'
import { Route as PublicRrhhSelfServiceTokenRouteImport } from './routes/public.rrhh.self-service.$token'
import { Route as AppComplianceIncidentesIdRouteImport } from './routes/_app/compliance/incidentes.$id'
import { Route as AppComplianceArcoIdRouteImport } from './routes/_app/compliance/arco.$id'

const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const PortalTributarioRoute = PortalTributarioRouteImport.update({
  id: '/tributario',
  path: '/tributario',
  getParentRoute: () => PortalRoute,
} as any)
const PortalOficinaVirtualRoute = PortalOficinaVirtualRouteImport.update({
  id: '/oficina-virtual',
  path: '/oficina-virtual',
  getParentRoute: () => PortalRoute,
} as any)
const PortalLoginRoute = PortalLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PortalRoute,
} as any)
const PortalFacturasRoute = PortalFacturasRouteImport.update({
  id: '/facturas',
  path: '/facturas',
  getParentRoute: () => PortalRoute,
} as any)
const PortalDashboardRoute = PortalDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PortalRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRrhhRouteRoute = AppRrhhRouteRouteImport.update({
  id: '/rrhh',
  path: '/rrhh',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRemuneracionesRouteRoute = AppRemuneracionesRouteRouteImport.update({
  id: '/remuneraciones',
  path: '/remuneraciones',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppF29RouteRoute = AppF29RouteRouteImport.update({
  id: '/f29',
  path: '/f29',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppControlRouteRoute = AppControlRouteRouteImport.update({
  id: '/control',
  path: '/control',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppComplianceRouteRoute = AppComplianceRouteRouteImport.update({
  id: '/compliance',
  path: '/compliance',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClientsRouteRoute = AppClientsRouteRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppVirtualOfficesIndexRoute = AppVirtualOfficesIndexRouteImport.update({
  id: '/virtual-offices/',
  path: '/virtual-offices/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTasksIndexRoute = AppTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppRrhhIndexRoute = AppRrhhIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRrhhRouteRoute,
} as any)
const AppRemuneracionesIndexRoute = AppRemuneracionesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRemuneracionesRouteRoute,
} as any)
const AppProduccionIndexRoute = AppProduccionIndexRouteImport.update({
  id: '/produccion/',
  path: '/produccion/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMessagingIndexRoute = AppMessagingIndexRouteImport.update({
  id: '/messaging/',
  path: '/messaging/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInformesIndexRoute = AppInformesIndexRouteImport.update({
  id: '/informes/',
  path: '/informes/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGestionesIndexRoute = AppGestionesIndexRouteImport.update({
  id: '/gestiones/',
  path: '/gestiones/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFacturacionIndexRoute = AppFacturacionIndexRouteImport.update({
  id: '/facturacion/',
  path: '/facturacion/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppF29IndexRoute = AppF29IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppF29RouteRoute,
} as any)
const AppEquipoIndexRoute = AppEquipoIndexRouteImport.update({
  id: '/equipo/',
  path: '/equipo/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDiagnosticoTributarioIndexRoute =
  AppDiagnosticoTributarioIndexRouteImport.update({
    id: '/diagnostico-tributario/',
    path: '/diagnostico-tributario/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCorreoIndexRoute = AppCorreoIndexRouteImport.update({
  id: '/correo/',
  path: '/correo/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppControlIndexRoute = AppControlIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppControlRouteRoute,
} as any)
const AppContratosIndexRoute = AppContratosIndexRouteImport.update({
  id: '/contratos/',
  path: '/contratos/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppComplianceIndexRoute = AppComplianceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppComplianceRouteRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClientsRouteRoute,
} as any)
const AppCaptacionIndexRoute = AppCaptacionIndexRouteImport.update({
  id: '/captacion/',
  path: '/captacion/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppApprovalsIndexRoute = AppApprovalsIndexRouteImport.update({
  id: '/approvals/',
  path: '/approvals/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthMfaEnrollRoute = AuthMfaEnrollRouteImport.update({
  id: '/auth/mfa/enroll',
  path: '/auth/mfa/enroll',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthMfaChallengeRoute = AuthMfaChallengeRouteImport.update({
  id: '/auth/mfa/challenge',
  path: '/auth/mfa/challenge',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVirtualOfficesSucursalesRoute =
  AppVirtualOfficesSucursalesRouteImport.update({
    id: '/virtual-offices/sucursales',
    path: '/virtual-offices/sucursales',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppVirtualOfficesCorrespondenciaRoute =
  AppVirtualOfficesCorrespondenciaRouteImport.update({
    id: '/virtual-offices/correspondencia',
    path: '/virtual-offices/correspondencia',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppVirtualOfficesAutorizacionesRoute =
  AppVirtualOfficesAutorizacionesRouteImport.update({
    id: '/virtual-offices/autorizaciones',
    path: '/virtual-offices/autorizaciones',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppTasksBitacoraRoute = AppTasksBitacoraRouteImport.update({
  id: '/tasks/bitacora',
  path: '/tasks/bitacora',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsWhatsappRoute = AppSettingsWhatsappRouteImport.update({
  id: '/whatsapp',
  path: '/whatsapp',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOvSedesRoute = AppSettingsOvSedesRouteImport.update({
  id: '/ov-sedes',
  path: '/ov-sedes',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOrganizationRoute = AppSettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsLostReasonsRoute = AppSettingsLostReasonsRouteImport.update({
  id: '/lost-reasons',
  path: '/lost-reasons',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsLaborParamsRoute = AppSettingsLaborParamsRouteImport.update({
  id: '/labor-params',
  path: '/labor-params',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsChannelsRoute = AppSettingsChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCampaignsRoute = AppSettingsCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCampaignLinksRoute =
  AppSettingsCampaignLinksRouteImport.update({
    id: '/campaign-links',
    path: '/campaign-links',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCamilaRoute = AppSettingsCamilaRouteImport.update({
  id: '/camila',
  path: '/camila',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppRrhhClientIdRoute = AppRrhhClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => AppRrhhRouteRoute,
} as any)
const AppRemuneracionesPreviredRoute =
  AppRemuneracionesPreviredRouteImport.update({
    id: '/previred',
    path: '/previred',
    getParentRoute: () => AppRemuneracionesRouteRoute,
  } as any)
const AppInformesDestinatariosRoute =
  AppInformesDestinatariosRouteImport.update({
    id: '/informes/destinatarios',
    path: '/informes/destinatarios',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppF29TemplatesRoute = AppF29TemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppF29RouteRoute,
} as any)
const AppF29LeerRoute = AppF29LeerRouteImport.update({
  id: '/leer',
  path: '/leer',
  getParentRoute: () => AppF29RouteRoute,
} as any)
const AppF29ColaRoute = AppF29ColaRouteImport.update({
  id: '/cola',
  path: '/cola',
  getParentRoute: () => AppF29RouteRoute,
} as any)
const AppDebugSimulateRoute = AppDebugSimulateRouteImport.update({
  id: '/debug/simulate',
  path: '/debug/simulate',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCorreoAuditDescarteRoute = AppCorreoAuditDescarteRouteImport.update({
  id: '/correo/audit-descarte',
  path: '/correo/audit-descarte',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppComplianceRatRoute = AppComplianceRatRouteImport.update({
  id: '/rat',
  path: '/rat',
  getParentRoute: () => AppComplianceRouteRoute,
} as any)
const AppComplianceIncidentesRoute = AppComplianceIncidentesRouteImport.update({
  id: '/incidentes',
  path: '/incidentes',
  getParentRoute: () => AppComplianceRouteRoute,
} as any)
const AppComplianceEventosRoute = AppComplianceEventosRouteImport.update({
  id: '/eventos',
  path: '/eventos',
  getParentRoute: () => AppComplianceRouteRoute,
} as any)
const AppComplianceContratosRoute = AppComplianceContratosRouteImport.update({
  id: '/contratos',
  path: '/contratos',
  getParentRoute: () => AppComplianceRouteRoute,
} as any)
const AppComplianceConsentimientosRoute =
  AppComplianceConsentimientosRouteImport.update({
    id: '/consentimientos',
    path: '/consentimientos',
    getParentRoute: () => AppComplianceRouteRoute,
  } as any)
const AppComplianceAuditoriaRoute = AppComplianceAuditoriaRouteImport.update({
  id: '/auditoria',
  path: '/auditoria',
  getParentRoute: () => AppComplianceRouteRoute,
} as any)
const AppComplianceArcoRoute = AppComplianceArcoRouteImport.update({
  id: '/arco',
  path: '/arco',
  getParentRoute: () => AppComplianceRouteRoute,
} as any)
const AppClientsEstadoRoute = AppClientsEstadoRouteImport.update({
  id: '/estado',
  path: '/estado',
  getParentRoute: () => AppClientsRouteRoute,
} as any)
const AppClientsBajasRoute = AppClientsBajasRouteImport.update({
  id: '/bajas',
  path: '/bajas',
  getParentRoute: () => AppClientsRouteRoute,
} as any)
const AppClientsArchivoRoute = AppClientsArchivoRouteImport.update({
  id: '/archivo',
  path: '/archivo',
  getParentRoute: () => AppClientsRouteRoute,
} as any)
const AppMessagingLogsIndexRoute = AppMessagingLogsIndexRouteImport.update({
  id: '/messaging/logs/',
  path: '/messaging/logs/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMessagingCampaignsIndexRoute =
  AppMessagingCampaignsIndexRouteImport.update({
    id: '/messaging/campaigns/',
    path: '/messaging/campaigns/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCrmLeadsIndexRoute = AppCrmLeadsIndexRouteImport.update({
  id: '/crm/leads/',
  path: '/crm/leads/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCrmCatalogIndexRoute = AppCrmCatalogIndexRouteImport.update({
  id: '/crm/catalog/',
  path: '/crm/catalog/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCrmAiActionsIndexRoute = AppCrmAiActionsIndexRouteImport.update({
  id: '/crm/ai-actions/',
  path: '/crm/ai-actions/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCorreoLogsIndexRoute = AppCorreoLogsIndexRouteImport.update({
  id: '/correo/logs/',
  path: '/correo/logs/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCorreoCampaignsIndexRoute = AppCorreoCampaignsIndexRouteImport.update({
  id: '/correo/campaigns/',
  path: '/correo/campaigns/',
  getParentRoute: () => AppRouteRoute,
} as any)
const PublicRrhhSelfServiceTokenRoute =
  PublicRrhhSelfServiceTokenRouteImport.update({
    id: '/public/rrhh/self-service/$token',
    path: '/public/rrhh/self-service/$token',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppComplianceIncidentesIdRoute =
  AppComplianceIncidentesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppComplianceIncidentesRoute,
  } as any)
const AppComplianceArcoIdRoute = AppComplianceArcoIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppComplianceArcoRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/clients': typeof AppClientsRouteRouteWithChildren
  '/compliance': typeof AppComplianceRouteRouteWithChildren
  '/control': typeof AppControlRouteRouteWithChildren
  '/f29': typeof AppF29RouteRouteWithChildren
  '/remuneraciones': typeof AppRemuneracionesRouteRouteWithChildren
  '/rrhh': typeof AppRrhhRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/portal/dashboard': typeof PortalDashboardRoute
  '/portal/facturas': typeof PortalFacturasRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal/oficina-virtual': typeof PortalOficinaVirtualRoute
  '/portal/tributario': typeof PortalTributarioRoute
  '/clients/archivo': typeof AppClientsArchivoRoute
  '/clients/bajas': typeof AppClientsBajasRoute
  '/clients/estado': typeof AppClientsEstadoRoute
  '/compliance/arco': typeof AppComplianceArcoRouteWithChildren
  '/compliance/auditoria': typeof AppComplianceAuditoriaRoute
  '/compliance/consentimientos': typeof AppComplianceConsentimientosRoute
  '/compliance/contratos': typeof AppComplianceContratosRoute
  '/compliance/eventos': typeof AppComplianceEventosRoute
  '/compliance/incidentes': typeof AppComplianceIncidentesRouteWithChildren
  '/compliance/rat': typeof AppComplianceRatRoute
  '/correo/audit-descarte': typeof AppCorreoAuditDescarteRoute
  '/debug/simulate': typeof AppDebugSimulateRoute
  '/f29/cola': typeof AppF29ColaRoute
  '/f29/leer': typeof AppF29LeerRoute
  '/f29/templates': typeof AppF29TemplatesRoute
  '/informes/destinatarios': typeof AppInformesDestinatariosRoute
  '/remuneraciones/previred': typeof AppRemuneracionesPreviredRoute
  '/rrhh/$clientId': typeof AppRrhhClientIdRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/camila': typeof AppSettingsCamilaRoute
  '/settings/campaign-links': typeof AppSettingsCampaignLinksRoute
  '/settings/campaigns': typeof AppSettingsCampaignsRoute
  '/settings/channels': typeof AppSettingsChannelsRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/labor-params': typeof AppSettingsLaborParamsRoute
  '/settings/lost-reasons': typeof AppSettingsLostReasonsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/organization': typeof AppSettingsOrganizationRoute
  '/settings/ov-sedes': typeof AppSettingsOvSedesRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/whatsapp': typeof AppSettingsWhatsappRoute
  '/tasks/bitacora': typeof AppTasksBitacoraRoute
  '/virtual-offices/autorizaciones': typeof AppVirtualOfficesAutorizacionesRoute
  '/virtual-offices/correspondencia': typeof AppVirtualOfficesCorrespondenciaRoute
  '/virtual-offices/sucursales': typeof AppVirtualOfficesSucursalesRoute
  '/auth/mfa/challenge': typeof AuthMfaChallengeRoute
  '/auth/mfa/enroll': typeof AuthMfaEnrollRoute
  '/approvals/': typeof AppApprovalsIndexRoute
  '/captacion/': typeof AppCaptacionIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/compliance/': typeof AppComplianceIndexRoute
  '/contratos/': typeof AppContratosIndexRoute
  '/control/': typeof AppControlIndexRoute
  '/correo/': typeof AppCorreoIndexRoute
  '/diagnostico-tributario/': typeof AppDiagnosticoTributarioIndexRoute
  '/equipo/': typeof AppEquipoIndexRoute
  '/f29/': typeof AppF29IndexRoute
  '/facturacion/': typeof AppFacturacionIndexRoute
  '/gestiones/': typeof AppGestionesIndexRoute
  '/informes/': typeof AppInformesIndexRoute
  '/messaging/': typeof AppMessagingIndexRoute
  '/produccion/': typeof AppProduccionIndexRoute
  '/remuneraciones/': typeof AppRemuneracionesIndexRoute
  '/rrhh/': typeof AppRrhhIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/tasks/': typeof AppTasksIndexRoute
  '/virtual-offices/': typeof AppVirtualOfficesIndexRoute
  '/compliance/arco/$id': typeof AppComplianceArcoIdRoute
  '/compliance/incidentes/$id': typeof AppComplianceIncidentesIdRoute
  '/public/rrhh/self-service/$token': typeof PublicRrhhSelfServiceTokenRoute
  '/correo/campaigns/': typeof AppCorreoCampaignsIndexRoute
  '/correo/logs/': typeof AppCorreoLogsIndexRoute
  '/crm/ai-actions/': typeof AppCrmAiActionsIndexRoute
  '/crm/catalog/': typeof AppCrmCatalogIndexRoute
  '/crm/leads/': typeof AppCrmLeadsIndexRoute
  '/messaging/campaigns/': typeof AppMessagingCampaignsIndexRoute
  '/messaging/logs/': typeof AppMessagingLogsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/portal/dashboard': typeof PortalDashboardRoute
  '/portal/facturas': typeof PortalFacturasRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal/oficina-virtual': typeof PortalOficinaVirtualRoute
  '/portal/tributario': typeof PortalTributarioRoute
  '/': typeof AppIndexRoute
  '/clients/archivo': typeof AppClientsArchivoRoute
  '/clients/bajas': typeof AppClientsBajasRoute
  '/clients/estado': typeof AppClientsEstadoRoute
  '/compliance/arco': typeof AppComplianceArcoRouteWithChildren
  '/compliance/auditoria': typeof AppComplianceAuditoriaRoute
  '/compliance/consentimientos': typeof AppComplianceConsentimientosRoute
  '/compliance/contratos': typeof AppComplianceContratosRoute
  '/compliance/eventos': typeof AppComplianceEventosRoute
  '/compliance/incidentes': typeof AppComplianceIncidentesRouteWithChildren
  '/compliance/rat': typeof AppComplianceRatRoute
  '/correo/audit-descarte': typeof AppCorreoAuditDescarteRoute
  '/debug/simulate': typeof AppDebugSimulateRoute
  '/f29/cola': typeof AppF29ColaRoute
  '/f29/leer': typeof AppF29LeerRoute
  '/f29/templates': typeof AppF29TemplatesRoute
  '/informes/destinatarios': typeof AppInformesDestinatariosRoute
  '/remuneraciones/previred': typeof AppRemuneracionesPreviredRoute
  '/rrhh/$clientId': typeof AppRrhhClientIdRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/camila': typeof AppSettingsCamilaRoute
  '/settings/campaign-links': typeof AppSettingsCampaignLinksRoute
  '/settings/campaigns': typeof AppSettingsCampaignsRoute
  '/settings/channels': typeof AppSettingsChannelsRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/labor-params': typeof AppSettingsLaborParamsRoute
  '/settings/lost-reasons': typeof AppSettingsLostReasonsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/organization': typeof AppSettingsOrganizationRoute
  '/settings/ov-sedes': typeof AppSettingsOvSedesRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/whatsapp': typeof AppSettingsWhatsappRoute
  '/tasks/bitacora': typeof AppTasksBitacoraRoute
  '/virtual-offices/autorizaciones': typeof AppVirtualOfficesAutorizacionesRoute
  '/virtual-offices/correspondencia': typeof AppVirtualOfficesCorrespondenciaRoute
  '/virtual-offices/sucursales': typeof AppVirtualOfficesSucursalesRoute
  '/auth/mfa/challenge': typeof AuthMfaChallengeRoute
  '/auth/mfa/enroll': typeof AuthMfaEnrollRoute
  '/approvals': typeof AppApprovalsIndexRoute
  '/captacion': typeof AppCaptacionIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/compliance': typeof AppComplianceIndexRoute
  '/contratos': typeof AppContratosIndexRoute
  '/control': typeof AppControlIndexRoute
  '/correo': typeof AppCorreoIndexRoute
  '/diagnostico-tributario': typeof AppDiagnosticoTributarioIndexRoute
  '/equipo': typeof AppEquipoIndexRoute
  '/f29': typeof AppF29IndexRoute
  '/facturacion': typeof AppFacturacionIndexRoute
  '/gestiones': typeof AppGestionesIndexRoute
  '/informes': typeof AppInformesIndexRoute
  '/messaging': typeof AppMessagingIndexRoute
  '/produccion': typeof AppProduccionIndexRoute
  '/remuneraciones': typeof AppRemuneracionesIndexRoute
  '/rrhh': typeof AppRrhhIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/tasks': typeof AppTasksIndexRoute
  '/virtual-offices': typeof AppVirtualOfficesIndexRoute
  '/compliance/arco/$id': typeof AppComplianceArcoIdRoute
  '/compliance/incidentes/$id': typeof AppComplianceIncidentesIdRoute
  '/public/rrhh/self-service/$token': typeof PublicRrhhSelfServiceTokenRoute
  '/correo/campaigns': typeof AppCorreoCampaignsIndexRoute
  '/correo/logs': typeof AppCorreoLogsIndexRoute
  '/crm/ai-actions': typeof AppCrmAiActionsIndexRoute
  '/crm/catalog': typeof AppCrmCatalogIndexRoute
  '/crm/leads': typeof AppCrmLeadsIndexRoute
  '/messaging/campaigns': typeof AppMessagingCampaignsIndexRoute
  '/messaging/logs': typeof AppMessagingLogsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/portal': typeof PortalRouteWithChildren
  '/_app/clients': typeof AppClientsRouteRouteWithChildren
  '/_app/compliance': typeof AppComplianceRouteRouteWithChildren
  '/_app/control': typeof AppControlRouteRouteWithChildren
  '/_app/f29': typeof AppF29RouteRouteWithChildren
  '/_app/remuneraciones': typeof AppRemuneracionesRouteRouteWithChildren
  '/_app/rrhh': typeof AppRrhhRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/portal/dashboard': typeof PortalDashboardRoute
  '/portal/facturas': typeof PortalFacturasRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal/oficina-virtual': typeof PortalOficinaVirtualRoute
  '/portal/tributario': typeof PortalTributarioRoute
  '/_app/': typeof AppIndexRoute
  '/_app/clients/archivo': typeof AppClientsArchivoRoute
  '/_app/clients/bajas': typeof AppClientsBajasRoute
  '/_app/clients/estado': typeof AppClientsEstadoRoute
  '/_app/compliance/arco': typeof AppComplianceArcoRouteWithChildren
  '/_app/compliance/auditoria': typeof AppComplianceAuditoriaRoute
  '/_app/compliance/consentimientos': typeof AppComplianceConsentimientosRoute
  '/_app/compliance/contratos': typeof AppComplianceContratosRoute
  '/_app/compliance/eventos': typeof AppComplianceEventosRoute
  '/_app/compliance/incidentes': typeof AppComplianceIncidentesRouteWithChildren
  '/_app/compliance/rat': typeof AppComplianceRatRoute
  '/_app/correo/audit-descarte': typeof AppCorreoAuditDescarteRoute
  '/_app/debug/simulate': typeof AppDebugSimulateRoute
  '/_app/f29/cola': typeof AppF29ColaRoute
  '/_app/f29/leer': typeof AppF29LeerRoute
  '/_app/f29/templates': typeof AppF29TemplatesRoute
  '/_app/informes/destinatarios': typeof AppInformesDestinatariosRoute
  '/_app/remuneraciones/previred': typeof AppRemuneracionesPreviredRoute
  '/_app/rrhh/$clientId': typeof AppRrhhClientIdRoute
  '/_app/settings/account': typeof AppSettingsAccountRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/camila': typeof AppSettingsCamilaRoute
  '/_app/settings/campaign-links': typeof AppSettingsCampaignLinksRoute
  '/_app/settings/campaigns': typeof AppSettingsCampaignsRoute
  '/_app/settings/channels': typeof AppSettingsChannelsRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/labor-params': typeof AppSettingsLaborParamsRoute
  '/_app/settings/lost-reasons': typeof AppSettingsLostReasonsRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/organization': typeof AppSettingsOrganizationRoute
  '/_app/settings/ov-sedes': typeof AppSettingsOvSedesRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/team': typeof AppSettingsTeamRoute
  '/_app/settings/whatsapp': typeof AppSettingsWhatsappRoute
  '/_app/tasks/bitacora': typeof AppTasksBitacoraRoute
  '/_app/virtual-offices/autorizaciones': typeof AppVirtualOfficesAutorizacionesRoute
  '/_app/virtual-offices/correspondencia': typeof AppVirtualOfficesCorrespondenciaRoute
  '/_app/virtual-offices/sucursales': typeof AppVirtualOfficesSucursalesRoute
  '/auth/mfa/challenge': typeof AuthMfaChallengeRoute
  '/auth/mfa/enroll': typeof AuthMfaEnrollRoute
  '/_app/approvals/': typeof AppApprovalsIndexRoute
  '/_app/captacion/': typeof AppCaptacionIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/compliance/': typeof AppComplianceIndexRoute
  '/_app/contratos/': typeof AppContratosIndexRoute
  '/_app/control/': typeof AppControlIndexRoute
  '/_app/correo/': typeof AppCorreoIndexRoute
  '/_app/diagnostico-tributario/': typeof AppDiagnosticoTributarioIndexRoute
  '/_app/equipo/': typeof AppEquipoIndexRoute
  '/_app/f29/': typeof AppF29IndexRoute
  '/_app/facturacion/': typeof AppFacturacionIndexRoute
  '/_app/gestiones/': typeof AppGestionesIndexRoute
  '/_app/informes/': typeof AppInformesIndexRoute
  '/_app/messaging/': typeof AppMessagingIndexRoute
  '/_app/produccion/': typeof AppProduccionIndexRoute
  '/_app/remuneraciones/': typeof AppRemuneracionesIndexRoute
  '/_app/rrhh/': typeof AppRrhhIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/tasks/': typeof AppTasksIndexRoute
  '/_app/virtual-offices/': typeof AppVirtualOfficesIndexRoute
  '/_app/compliance/arco/$id': typeof AppComplianceArcoIdRoute
  '/_app/compliance/incidentes/$id': typeof AppComplianceIncidentesIdRoute
  '/public/rrhh/self-service/$token': typeof PublicRrhhSelfServiceTokenRoute
  '/_app/correo/campaigns/': typeof AppCorreoCampaignsIndexRoute
  '/_app/correo/logs/': typeof AppCorreoLogsIndexRoute
  '/_app/crm/ai-actions/': typeof AppCrmAiActionsIndexRoute
  '/_app/crm/catalog/': typeof AppCrmCatalogIndexRoute
  '/_app/crm/leads/': typeof AppCrmLeadsIndexRoute
  '/_app/messaging/campaigns/': typeof AppMessagingCampaignsIndexRoute
  '/_app/messaging/logs/': typeof AppMessagingLogsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/portal'
    | '/clients'
    | '/compliance'
    | '/control'
    | '/f29'
    | '/remuneraciones'
    | '/rrhh'
    | '/settings'
    | '/auth/callback'
    | '/portal/dashboard'
    | '/portal/facturas'
    | '/portal/login'
    | '/portal/oficina-virtual'
    | '/portal/tributario'
    | '/clients/archivo'
    | '/clients/bajas'
    | '/clients/estado'
    | '/compliance/arco'
    | '/compliance/auditoria'
    | '/compliance/consentimientos'
    | '/compliance/contratos'
    | '/compliance/eventos'
    | '/compliance/incidentes'
    | '/compliance/rat'
    | '/correo/audit-descarte'
    | '/debug/simulate'
    | '/f29/cola'
    | '/f29/leer'
    | '/f29/templates'
    | '/informes/destinatarios'
    | '/remuneraciones/previred'
    | '/rrhh/$clientId'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/camila'
    | '/settings/campaign-links'
    | '/settings/campaigns'
    | '/settings/channels'
    | '/settings/integrations'
    | '/settings/labor-params'
    | '/settings/lost-reasons'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/ov-sedes'
    | '/settings/security'
    | '/settings/team'
    | '/settings/whatsapp'
    | '/tasks/bitacora'
    | '/virtual-offices/autorizaciones'
    | '/virtual-offices/correspondencia'
    | '/virtual-offices/sucursales'
    | '/auth/mfa/challenge'
    | '/auth/mfa/enroll'
    | '/approvals/'
    | '/captacion/'
    | '/clients/'
    | '/compliance/'
    | '/contratos/'
    | '/control/'
    | '/correo/'
    | '/diagnostico-tributario/'
    | '/equipo/'
    | '/f29/'
    | '/facturacion/'
    | '/gestiones/'
    | '/informes/'
    | '/messaging/'
    | '/produccion/'
    | '/remuneraciones/'
    | '/rrhh/'
    | '/settings/'
    | '/tasks/'
    | '/virtual-offices/'
    | '/compliance/arco/$id'
    | '/compliance/incidentes/$id'
    | '/public/rrhh/self-service/$token'
    | '/correo/campaigns/'
    | '/correo/logs/'
    | '/crm/ai-actions/'
    | '/crm/catalog/'
    | '/crm/leads/'
    | '/messaging/campaigns/'
    | '/messaging/logs/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/portal'
    | '/auth/callback'
    | '/portal/dashboard'
    | '/portal/facturas'
    | '/portal/login'
    | '/portal/oficina-virtual'
    | '/portal/tributario'
    | '/'
    | '/clients/archivo'
    | '/clients/bajas'
    | '/clients/estado'
    | '/compliance/arco'
    | '/compliance/auditoria'
    | '/compliance/consentimientos'
    | '/compliance/contratos'
    | '/compliance/eventos'
    | '/compliance/incidentes'
    | '/compliance/rat'
    | '/correo/audit-descarte'
    | '/debug/simulate'
    | '/f29/cola'
    | '/f29/leer'
    | '/f29/templates'
    | '/informes/destinatarios'
    | '/remuneraciones/previred'
    | '/rrhh/$clientId'
    | '/settings/account'
    | '/settings/billing'
    | '/settings/camila'
    | '/settings/campaign-links'
    | '/settings/campaigns'
    | '/settings/channels'
    | '/settings/integrations'
    | '/settings/labor-params'
    | '/settings/lost-reasons'
    | '/settings/notifications'
    | '/settings/organization'
    | '/settings/ov-sedes'
    | '/settings/security'
    | '/settings/team'
    | '/settings/whatsapp'
    | '/tasks/bitacora'
    | '/virtual-offices/autorizaciones'
    | '/virtual-offices/correspondencia'
    | '/virtual-offices/sucursales'
    | '/auth/mfa/challenge'
    | '/auth/mfa/enroll'
    | '/approvals'
    | '/captacion'
    | '/clients'
    | '/compliance'
    | '/contratos'
    | '/control'
    | '/correo'
    | '/diagnostico-tributario'
    | '/equipo'
    | '/f29'
    | '/facturacion'
    | '/gestiones'
    | '/informes'
    | '/messaging'
    | '/produccion'
    | '/remuneraciones'
    | '/rrhh'
    | '/settings'
    | '/tasks'
    | '/virtual-offices'
    | '/compliance/arco/$id'
    | '/compliance/incidentes/$id'
    | '/public/rrhh/self-service/$token'
    | '/correo/campaigns'
    | '/correo/logs'
    | '/crm/ai-actions'
    | '/crm/catalog'
    | '/crm/leads'
    | '/messaging/campaigns'
    | '/messaging/logs'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/portal'
    | '/_app/clients'
    | '/_app/compliance'
    | '/_app/control'
    | '/_app/f29'
    | '/_app/remuneraciones'
    | '/_app/rrhh'
    | '/_app/settings'
    | '/auth/callback'
    | '/portal/dashboard'
    | '/portal/facturas'
    | '/portal/login'
    | '/portal/oficina-virtual'
    | '/portal/tributario'
    | '/_app/'
    | '/_app/clients/archivo'
    | '/_app/clients/bajas'
    | '/_app/clients/estado'
    | '/_app/compliance/arco'
    | '/_app/compliance/auditoria'
    | '/_app/compliance/consentimientos'
    | '/_app/compliance/contratos'
    | '/_app/compliance/eventos'
    | '/_app/compliance/incidentes'
    | '/_app/compliance/rat'
    | '/_app/correo/audit-descarte'
    | '/_app/debug/simulate'
    | '/_app/f29/cola'
    | '/_app/f29/leer'
    | '/_app/f29/templates'
    | '/_app/informes/destinatarios'
    | '/_app/remuneraciones/previred'
    | '/_app/rrhh/$clientId'
    | '/_app/settings/account'
    | '/_app/settings/billing'
    | '/_app/settings/camila'
    | '/_app/settings/campaign-links'
    | '/_app/settings/campaigns'
    | '/_app/settings/channels'
    | '/_app/settings/integrations'
    | '/_app/settings/labor-params'
    | '/_app/settings/lost-reasons'
    | '/_app/settings/notifications'
    | '/_app/settings/organization'
    | '/_app/settings/ov-sedes'
    | '/_app/settings/security'
    | '/_app/settings/team'
    | '/_app/settings/whatsapp'
    | '/_app/tasks/bitacora'
    | '/_app/virtual-offices/autorizaciones'
    | '/_app/virtual-offices/correspondencia'
    | '/_app/virtual-offices/sucursales'
    | '/auth/mfa/challenge'
    | '/auth/mfa/enroll'
    | '/_app/approvals/'
    | '/_app/captacion/'
    | '/_app/clients/'
    | '/_app/compliance/'
    | '/_app/contratos/'
    | '/_app/control/'
    | '/_app/correo/'
    | '/_app/diagnostico-tributario/'
    | '/_app/equipo/'
    | '/_app/f29/'
    | '/_app/facturacion/'
    | '/_app/gestiones/'
    | '/_app/informes/'
    | '/_app/messaging/'
    | '/_app/produccion/'
    | '/_app/remuneraciones/'
    | '/_app/rrhh/'
    | '/_app/settings/'
    | '/_app/tasks/'
    | '/_app/virtual-offices/'
    | '/_app/compliance/arco/$id'
    | '/_app/compliance/incidentes/$id'
    | '/public/rrhh/self-service/$token'
    | '/_app/correo/campaigns/'
    | '/_app/correo/logs/'
    | '/_app/crm/ai-actions/'
    | '/_app/crm/catalog/'
    | '/_app/crm/leads/'
    | '/_app/messaging/campaigns/'
    | '/_app/messaging/logs/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  PortalRoute: typeof PortalRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthMfaChallengeRoute: typeof AuthMfaChallengeRoute
  AuthMfaEnrollRoute: typeof AuthMfaEnrollRoute
  PublicRrhhSelfServiceTokenRoute: typeof PublicRrhhSelfServiceTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/portal/tributario': {
      id: '/portal/tributario'
      path: '/tributario'
      fullPath: '/portal/tributario'
      preLoaderRoute: typeof PortalTributarioRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/oficina-virtual': {
      id: '/portal/oficina-virtual'
      path: '/oficina-virtual'
      fullPath: '/portal/oficina-virtual'
      preLoaderRoute: typeof PortalOficinaVirtualRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/login': {
      id: '/portal/login'
      path: '/login'
      fullPath: '/portal/login'
      preLoaderRoute: typeof PortalLoginRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/facturas': {
      id: '/portal/facturas'
      path: '/facturas'
      fullPath: '/portal/facturas'
      preLoaderRoute: typeof PortalFacturasRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/dashboard': {
      id: '/portal/dashboard'
      path: '/dashboard'
      fullPath: '/portal/dashboard'
      preLoaderRoute: typeof PortalDashboardRouteImport
      parentRoute: typeof PortalRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/rrhh': {
      id: '/_app/rrhh'
      path: '/rrhh'
      fullPath: '/rrhh'
      preLoaderRoute: typeof AppRrhhRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/remuneraciones': {
      id: '/_app/remuneraciones'
      path: '/remuneraciones'
      fullPath: '/remuneraciones'
      preLoaderRoute: typeof AppRemuneracionesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/f29': {
      id: '/_app/f29'
      path: '/f29'
      fullPath: '/f29'
      preLoaderRoute: typeof AppF29RouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/control': {
      id: '/_app/control'
      path: '/control'
      fullPath: '/control'
      preLoaderRoute: typeof AppControlRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/compliance': {
      id: '/_app/compliance'
      path: '/compliance'
      fullPath: '/compliance'
      preLoaderRoute: typeof AppComplianceRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/virtual-offices/': {
      id: '/_app/virtual-offices/'
      path: '/virtual-offices'
      fullPath: '/virtual-offices/'
      preLoaderRoute: typeof AppVirtualOfficesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tasks/': {
      id: '/_app/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AppTasksIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/rrhh/': {
      id: '/_app/rrhh/'
      path: '/'
      fullPath: '/rrhh/'
      preLoaderRoute: typeof AppRrhhIndexRouteImport
      parentRoute: typeof AppRrhhRouteRoute
    }
    '/_app/remuneraciones/': {
      id: '/_app/remuneraciones/'
      path: '/'
      fullPath: '/remuneraciones/'
      preLoaderRoute: typeof AppRemuneracionesIndexRouteImport
      parentRoute: typeof AppRemuneracionesRouteRoute
    }
    '/_app/produccion/': {
      id: '/_app/produccion/'
      path: '/produccion'
      fullPath: '/produccion/'
      preLoaderRoute: typeof AppProduccionIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/messaging/': {
      id: '/_app/messaging/'
      path: '/messaging'
      fullPath: '/messaging/'
      preLoaderRoute: typeof AppMessagingIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/informes/': {
      id: '/_app/informes/'
      path: '/informes'
      fullPath: '/informes/'
      preLoaderRoute: typeof AppInformesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/gestiones/': {
      id: '/_app/gestiones/'
      path: '/gestiones'
      fullPath: '/gestiones/'
      preLoaderRoute: typeof AppGestionesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/facturacion/': {
      id: '/_app/facturacion/'
      path: '/facturacion'
      fullPath: '/facturacion/'
      preLoaderRoute: typeof AppFacturacionIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/f29/': {
      id: '/_app/f29/'
      path: '/'
      fullPath: '/f29/'
      preLoaderRoute: typeof AppF29IndexRouteImport
      parentRoute: typeof AppF29RouteRoute
    }
    '/_app/equipo/': {
      id: '/_app/equipo/'
      path: '/equipo'
      fullPath: '/equipo/'
      preLoaderRoute: typeof AppEquipoIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/diagnostico-tributario/': {
      id: '/_app/diagnostico-tributario/'
      path: '/diagnostico-tributario'
      fullPath: '/diagnostico-tributario/'
      preLoaderRoute: typeof AppDiagnosticoTributarioIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/correo/': {
      id: '/_app/correo/'
      path: '/correo'
      fullPath: '/correo/'
      preLoaderRoute: typeof AppCorreoIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/control/': {
      id: '/_app/control/'
      path: '/'
      fullPath: '/control/'
      preLoaderRoute: typeof AppControlIndexRouteImport
      parentRoute: typeof AppControlRouteRoute
    }
    '/_app/contratos/': {
      id: '/_app/contratos/'
      path: '/contratos'
      fullPath: '/contratos/'
      preLoaderRoute: typeof AppContratosIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/compliance/': {
      id: '/_app/compliance/'
      path: '/'
      fullPath: '/compliance/'
      preLoaderRoute: typeof AppComplianceIndexRouteImport
      parentRoute: typeof AppComplianceRouteRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppClientsRouteRoute
    }
    '/_app/captacion/': {
      id: '/_app/captacion/'
      path: '/captacion'
      fullPath: '/captacion/'
      preLoaderRoute: typeof AppCaptacionIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/approvals/': {
      id: '/_app/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof AppApprovalsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/mfa/enroll': {
      id: '/auth/mfa/enroll'
      path: '/auth/mfa/enroll'
      fullPath: '/auth/mfa/enroll'
      preLoaderRoute: typeof AuthMfaEnrollRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/mfa/challenge': {
      id: '/auth/mfa/challenge'
      path: '/auth/mfa/challenge'
      fullPath: '/auth/mfa/challenge'
      preLoaderRoute: typeof AuthMfaChallengeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/virtual-offices/sucursales': {
      id: '/_app/virtual-offices/sucursales'
      path: '/virtual-offices/sucursales'
      fullPath: '/virtual-offices/sucursales'
      preLoaderRoute: typeof AppVirtualOfficesSucursalesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/virtual-offices/correspondencia': {
      id: '/_app/virtual-offices/correspondencia'
      path: '/virtual-offices/correspondencia'
      fullPath: '/virtual-offices/correspondencia'
      preLoaderRoute: typeof AppVirtualOfficesCorrespondenciaRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/virtual-offices/autorizaciones': {
      id: '/_app/virtual-offices/autorizaciones'
      path: '/virtual-offices/autorizaciones'
      fullPath: '/virtual-offices/autorizaciones'
      preLoaderRoute: typeof AppVirtualOfficesAutorizacionesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tasks/bitacora': {
      id: '/_app/tasks/bitacora'
      path: '/tasks/bitacora'
      fullPath: '/tasks/bitacora'
      preLoaderRoute: typeof AppTasksBitacoraRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/whatsapp': {
      id: '/_app/settings/whatsapp'
      path: '/whatsapp'
      fullPath: '/settings/whatsapp'
      preLoaderRoute: typeof AppSettingsWhatsappRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/team': {
      id: '/_app/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/ov-sedes': {
      id: '/_app/settings/ov-sedes'
      path: '/ov-sedes'
      fullPath: '/settings/ov-sedes'
      preLoaderRoute: typeof AppSettingsOvSedesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/organization': {
      id: '/_app/settings/organization'
      path: '/organization'
      fullPath: '/settings/organization'
      preLoaderRoute: typeof AppSettingsOrganizationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/lost-reasons': {
      id: '/_app/settings/lost-reasons'
      path: '/lost-reasons'
      fullPath: '/settings/lost-reasons'
      preLoaderRoute: typeof AppSettingsLostReasonsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/labor-params': {
      id: '/_app/settings/labor-params'
      path: '/labor-params'
      fullPath: '/settings/labor-params'
      preLoaderRoute: typeof AppSettingsLaborParamsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/channels': {
      id: '/_app/settings/channels'
      path: '/channels'
      fullPath: '/settings/channels'
      preLoaderRoute: typeof AppSettingsChannelsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/campaigns': {
      id: '/_app/settings/campaigns'
      path: '/campaigns'
      fullPath: '/settings/campaigns'
      preLoaderRoute: typeof AppSettingsCampaignsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/campaign-links': {
      id: '/_app/settings/campaign-links'
      path: '/campaign-links'
      fullPath: '/settings/campaign-links'
      preLoaderRoute: typeof AppSettingsCampaignLinksRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/camila': {
      id: '/_app/settings/camila'
      path: '/camila'
      fullPath: '/settings/camila'
      preLoaderRoute: typeof AppSettingsCamilaRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/account': {
      id: '/_app/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppSettingsAccountRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/rrhh/$clientId': {
      id: '/_app/rrhh/$clientId'
      path: '/$clientId'
      fullPath: '/rrhh/$clientId'
      preLoaderRoute: typeof AppRrhhClientIdRouteImport
      parentRoute: typeof AppRrhhRouteRoute
    }
    '/_app/remuneraciones/previred': {
      id: '/_app/remuneraciones/previred'
      path: '/previred'
      fullPath: '/remuneraciones/previred'
      preLoaderRoute: typeof AppRemuneracionesPreviredRouteImport
      parentRoute: typeof AppRemuneracionesRouteRoute
    }
    '/_app/informes/destinatarios': {
      id: '/_app/informes/destinatarios'
      path: '/informes/destinatarios'
      fullPath: '/informes/destinatarios'
      preLoaderRoute: typeof AppInformesDestinatariosRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/f29/templates': {
      id: '/_app/f29/templates'
      path: '/templates'
      fullPath: '/f29/templates'
      preLoaderRoute: typeof AppF29TemplatesRouteImport
      parentRoute: typeof AppF29RouteRoute
    }
    '/_app/f29/leer': {
      id: '/_app/f29/leer'
      path: '/leer'
      fullPath: '/f29/leer'
      preLoaderRoute: typeof AppF29LeerRouteImport
      parentRoute: typeof AppF29RouteRoute
    }
    '/_app/f29/cola': {
      id: '/_app/f29/cola'
      path: '/cola'
      fullPath: '/f29/cola'
      preLoaderRoute: typeof AppF29ColaRouteImport
      parentRoute: typeof AppF29RouteRoute
    }
    '/_app/debug/simulate': {
      id: '/_app/debug/simulate'
      path: '/debug/simulate'
      fullPath: '/debug/simulate'
      preLoaderRoute: typeof AppDebugSimulateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/correo/audit-descarte': {
      id: '/_app/correo/audit-descarte'
      path: '/correo/audit-descarte'
      fullPath: '/correo/audit-descarte'
      preLoaderRoute: typeof AppCorreoAuditDescarteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/compliance/rat': {
      id: '/_app/compliance/rat'
      path: '/rat'
      fullPath: '/compliance/rat'
      preLoaderRoute: typeof AppComplianceRatRouteImport
      parentRoute: typeof AppComplianceRouteRoute
    }
    '/_app/compliance/incidentes': {
      id: '/_app/compliance/incidentes'
      path: '/incidentes'
      fullPath: '/compliance/incidentes'
      preLoaderRoute: typeof AppComplianceIncidentesRouteImport
      parentRoute: typeof AppComplianceRouteRoute
    }
    '/_app/compliance/eventos': {
      id: '/_app/compliance/eventos'
      path: '/eventos'
      fullPath: '/compliance/eventos'
      preLoaderRoute: typeof AppComplianceEventosRouteImport
      parentRoute: typeof AppComplianceRouteRoute
    }
    '/_app/compliance/contratos': {
      id: '/_app/compliance/contratos'
      path: '/contratos'
      fullPath: '/compliance/contratos'
      preLoaderRoute: typeof AppComplianceContratosRouteImport
      parentRoute: typeof AppComplianceRouteRoute
    }
    '/_app/compliance/consentimientos': {
      id: '/_app/compliance/consentimientos'
      path: '/consentimientos'
      fullPath: '/compliance/consentimientos'
      preLoaderRoute: typeof AppComplianceConsentimientosRouteImport
      parentRoute: typeof AppComplianceRouteRoute
    }
    '/_app/compliance/auditoria': {
      id: '/_app/compliance/auditoria'
      path: '/auditoria'
      fullPath: '/compliance/auditoria'
      preLoaderRoute: typeof AppComplianceAuditoriaRouteImport
      parentRoute: typeof AppComplianceRouteRoute
    }
    '/_app/compliance/arco': {
      id: '/_app/compliance/arco'
      path: '/arco'
      fullPath: '/compliance/arco'
      preLoaderRoute: typeof AppComplianceArcoRouteImport
      parentRoute: typeof AppComplianceRouteRoute
    }
    '/_app/clients/estado': {
      id: '/_app/clients/estado'
      path: '/estado'
      fullPath: '/clients/estado'
      preLoaderRoute: typeof AppClientsEstadoRouteImport
      parentRoute: typeof AppClientsRouteRoute
    }
    '/_app/clients/bajas': {
      id: '/_app/clients/bajas'
      path: '/bajas'
      fullPath: '/clients/bajas'
      preLoaderRoute: typeof AppClientsBajasRouteImport
      parentRoute: typeof AppClientsRouteRoute
    }
    '/_app/clients/archivo': {
      id: '/_app/clients/archivo'
      path: '/archivo'
      fullPath: '/clients/archivo'
      preLoaderRoute: typeof AppClientsArchivoRouteImport
      parentRoute: typeof AppClientsRouteRoute
    }
    '/_app/messaging/logs/': {
      id: '/_app/messaging/logs/'
      path: '/messaging/logs'
      fullPath: '/messaging/logs/'
      preLoaderRoute: typeof AppMessagingLogsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/messaging/campaigns/': {
      id: '/_app/messaging/campaigns/'
      path: '/messaging/campaigns'
      fullPath: '/messaging/campaigns/'
      preLoaderRoute: typeof AppMessagingCampaignsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/crm/leads/': {
      id: '/_app/crm/leads/'
      path: '/crm/leads'
      fullPath: '/crm/leads/'
      preLoaderRoute: typeof AppCrmLeadsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/crm/catalog/': {
      id: '/_app/crm/catalog/'
      path: '/crm/catalog'
      fullPath: '/crm/catalog/'
      preLoaderRoute: typeof AppCrmCatalogIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/crm/ai-actions/': {
      id: '/_app/crm/ai-actions/'
      path: '/crm/ai-actions'
      fullPath: '/crm/ai-actions/'
      preLoaderRoute: typeof AppCrmAiActionsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/correo/logs/': {
      id: '/_app/correo/logs/'
      path: '/correo/logs'
      fullPath: '/correo/logs/'
      preLoaderRoute: typeof AppCorreoLogsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/correo/campaigns/': {
      id: '/_app/correo/campaigns/'
      path: '/correo/campaigns'
      fullPath: '/correo/campaigns/'
      preLoaderRoute: typeof AppCorreoCampaignsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/public/rrhh/self-service/$token': {
      id: '/public/rrhh/self-service/$token'
      path: '/public/rrhh/self-service/$token'
      fullPath: '/public/rrhh/self-service/$token'
      preLoaderRoute: typeof PublicRrhhSelfServiceTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/compliance/incidentes/$id': {
      id: '/_app/compliance/incidentes/$id'
      path: '/$id'
      fullPath: '/compliance/incidentes/$id'
      preLoaderRoute: typeof AppComplianceIncidentesIdRouteImport
      parentRoute: typeof AppComplianceIncidentesRoute
    }
    '/_app/compliance/arco/$id': {
      id: '/_app/compliance/arco/$id'
      path: '/$id'
      fullPath: '/compliance/arco/$id'
      preLoaderRoute: typeof AppComplianceArcoIdRouteImport
      parentRoute: typeof AppComplianceArcoRoute
    }
  }
}

interface AppClientsRouteRouteChildren {
  AppClientsArchivoRoute: typeof AppClientsArchivoRoute
  AppClientsBajasRoute: typeof AppClientsBajasRoute
  AppClientsEstadoRoute: typeof AppClientsEstadoRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
}

const AppClientsRouteRouteChildren: AppClientsRouteRouteChildren = {
  AppClientsArchivoRoute: AppClientsArchivoRoute,
  AppClientsBajasRoute: AppClientsBajasRoute,
  AppClientsEstadoRoute: AppClientsEstadoRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
}

const AppClientsRouteRouteWithChildren = AppClientsRouteRoute._addFileChildren(
  AppClientsRouteRouteChildren,
)

interface AppComplianceArcoRouteChildren {
  AppComplianceArcoIdRoute: typeof AppComplianceArcoIdRoute
}

const AppComplianceArcoRouteChildren: AppComplianceArcoRouteChildren = {
  AppComplianceArcoIdRoute: AppComplianceArcoIdRoute,
}

const AppComplianceArcoRouteWithChildren =
  AppComplianceArcoRoute._addFileChildren(AppComplianceArcoRouteChildren)

interface AppComplianceIncidentesRouteChildren {
  AppComplianceIncidentesIdRoute: typeof AppComplianceIncidentesIdRoute
}

const AppComplianceIncidentesRouteChildren: AppComplianceIncidentesRouteChildren =
  {
    AppComplianceIncidentesIdRoute: AppComplianceIncidentesIdRoute,
  }

const AppComplianceIncidentesRouteWithChildren =
  AppComplianceIncidentesRoute._addFileChildren(
    AppComplianceIncidentesRouteChildren,
  )

interface AppComplianceRouteRouteChildren {
  AppComplianceArcoRoute: typeof AppComplianceArcoRouteWithChildren
  AppComplianceAuditoriaRoute: typeof AppComplianceAuditoriaRoute
  AppComplianceConsentimientosRoute: typeof AppComplianceConsentimientosRoute
  AppComplianceContratosRoute: typeof AppComplianceContratosRoute
  AppComplianceEventosRoute: typeof AppComplianceEventosRoute
  AppComplianceIncidentesRoute: typeof AppComplianceIncidentesRouteWithChildren
  AppComplianceRatRoute: typeof AppComplianceRatRoute
  AppComplianceIndexRoute: typeof AppComplianceIndexRoute
}

const AppComplianceRouteRouteChildren: AppComplianceRouteRouteChildren = {
  AppComplianceArcoRoute: AppComplianceArcoRouteWithChildren,
  AppComplianceAuditoriaRoute: AppComplianceAuditoriaRoute,
  AppComplianceConsentimientosRoute: AppComplianceConsentimientosRoute,
  AppComplianceContratosRoute: AppComplianceContratosRoute,
  AppComplianceEventosRoute: AppComplianceEventosRoute,
  AppComplianceIncidentesRoute: AppComplianceIncidentesRouteWithChildren,
  AppComplianceRatRoute: AppComplianceRatRoute,
  AppComplianceIndexRoute: AppComplianceIndexRoute,
}

const AppComplianceRouteRouteWithChildren =
  AppComplianceRouteRoute._addFileChildren(AppComplianceRouteRouteChildren)

interface AppControlRouteRouteChildren {
  AppControlIndexRoute: typeof AppControlIndexRoute
}

const AppControlRouteRouteChildren: AppControlRouteRouteChildren = {
  AppControlIndexRoute: AppControlIndexRoute,
}

const AppControlRouteRouteWithChildren = AppControlRouteRoute._addFileChildren(
  AppControlRouteRouteChildren,
)

interface AppF29RouteRouteChildren {
  AppF29ColaRoute: typeof AppF29ColaRoute
  AppF29LeerRoute: typeof AppF29LeerRoute
  AppF29TemplatesRoute: typeof AppF29TemplatesRoute
  AppF29IndexRoute: typeof AppF29IndexRoute
}

const AppF29RouteRouteChildren: AppF29RouteRouteChildren = {
  AppF29ColaRoute: AppF29ColaRoute,
  AppF29LeerRoute: AppF29LeerRoute,
  AppF29TemplatesRoute: AppF29TemplatesRoute,
  AppF29IndexRoute: AppF29IndexRoute,
}

const AppF29RouteRouteWithChildren = AppF29RouteRoute._addFileChildren(
  AppF29RouteRouteChildren,
)

interface AppRemuneracionesRouteRouteChildren {
  AppRemuneracionesPreviredRoute: typeof AppRemuneracionesPreviredRoute
  AppRemuneracionesIndexRoute: typeof AppRemuneracionesIndexRoute
}

const AppRemuneracionesRouteRouteChildren: AppRemuneracionesRouteRouteChildren =
  {
    AppRemuneracionesPreviredRoute: AppRemuneracionesPreviredRoute,
    AppRemuneracionesIndexRoute: AppRemuneracionesIndexRoute,
  }

const AppRemuneracionesRouteRouteWithChildren =
  AppRemuneracionesRouteRoute._addFileChildren(
    AppRemuneracionesRouteRouteChildren,
  )

interface AppRrhhRouteRouteChildren {
  AppRrhhClientIdRoute: typeof AppRrhhClientIdRoute
  AppRrhhIndexRoute: typeof AppRrhhIndexRoute
}

const AppRrhhRouteRouteChildren: AppRrhhRouteRouteChildren = {
  AppRrhhClientIdRoute: AppRrhhClientIdRoute,
  AppRrhhIndexRoute: AppRrhhIndexRoute,
}

const AppRrhhRouteRouteWithChildren = AppRrhhRouteRoute._addFileChildren(
  AppRrhhRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsCamilaRoute: typeof AppSettingsCamilaRoute
  AppSettingsCampaignLinksRoute: typeof AppSettingsCampaignLinksRoute
  AppSettingsCampaignsRoute: typeof AppSettingsCampaignsRoute
  AppSettingsChannelsRoute: typeof AppSettingsChannelsRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsLaborParamsRoute: typeof AppSettingsLaborParamsRoute
  AppSettingsLostReasonsRoute: typeof AppSettingsLostReasonsRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsOrganizationRoute: typeof AppSettingsOrganizationRoute
  AppSettingsOvSedesRoute: typeof AppSettingsOvSedesRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppSettingsWhatsappRoute: typeof AppSettingsWhatsappRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsCamilaRoute: AppSettingsCamilaRoute,
  AppSettingsCampaignLinksRoute: AppSettingsCampaignLinksRoute,
  AppSettingsCampaignsRoute: AppSettingsCampaignsRoute,
  AppSettingsChannelsRoute: AppSettingsChannelsRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsLaborParamsRoute: AppSettingsLaborParamsRoute,
  AppSettingsLostReasonsRoute: AppSettingsLostReasonsRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsOrganizationRoute: AppSettingsOrganizationRoute,
  AppSettingsOvSedesRoute: AppSettingsOvSedesRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsWhatsappRoute: AppSettingsWhatsappRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppClientsRouteRoute: typeof AppClientsRouteRouteWithChildren
  AppComplianceRouteRoute: typeof AppComplianceRouteRouteWithChildren
  AppControlRouteRoute: typeof AppControlRouteRouteWithChildren
  AppF29RouteRoute: typeof AppF29RouteRouteWithChildren
  AppRemuneracionesRouteRoute: typeof AppRemuneracionesRouteRouteWithChildren
  AppRrhhRouteRoute: typeof AppRrhhRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppCorreoAuditDescarteRoute: typeof AppCorreoAuditDescarteRoute
  AppDebugSimulateRoute: typeof AppDebugSimulateRoute
  AppInformesDestinatariosRoute: typeof AppInformesDestinatariosRoute
  AppTasksBitacoraRoute: typeof AppTasksBitacoraRoute
  AppVirtualOfficesAutorizacionesRoute: typeof AppVirtualOfficesAutorizacionesRoute
  AppVirtualOfficesCorrespondenciaRoute: typeof AppVirtualOfficesCorrespondenciaRoute
  AppVirtualOfficesSucursalesRoute: typeof AppVirtualOfficesSucursalesRoute
  AppApprovalsIndexRoute: typeof AppApprovalsIndexRoute
  AppCaptacionIndexRoute: typeof AppCaptacionIndexRoute
  AppContratosIndexRoute: typeof AppContratosIndexRoute
  AppCorreoIndexRoute: typeof AppCorreoIndexRoute
  AppDiagnosticoTributarioIndexRoute: typeof AppDiagnosticoTributarioIndexRoute
  AppEquipoIndexRoute: typeof AppEquipoIndexRoute
  AppFacturacionIndexRoute: typeof AppFacturacionIndexRoute
  AppGestionesIndexRoute: typeof AppGestionesIndexRoute
  AppInformesIndexRoute: typeof AppInformesIndexRoute
  AppMessagingIndexRoute: typeof AppMessagingIndexRoute
  AppProduccionIndexRoute: typeof AppProduccionIndexRoute
  AppTasksIndexRoute: typeof AppTasksIndexRoute
  AppVirtualOfficesIndexRoute: typeof AppVirtualOfficesIndexRoute
  AppCorreoCampaignsIndexRoute: typeof AppCorreoCampaignsIndexRoute
  AppCorreoLogsIndexRoute: typeof AppCorreoLogsIndexRoute
  AppCrmAiActionsIndexRoute: typeof AppCrmAiActionsIndexRoute
  AppCrmCatalogIndexRoute: typeof AppCrmCatalogIndexRoute
  AppCrmLeadsIndexRoute: typeof AppCrmLeadsIndexRoute
  AppMessagingCampaignsIndexRoute: typeof AppMessagingCampaignsIndexRoute
  AppMessagingLogsIndexRoute: typeof AppMessagingLogsIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppClientsRouteRoute: AppClientsRouteRouteWithChildren,
  AppComplianceRouteRoute: AppComplianceRouteRouteWithChildren,
  AppControlRouteRoute: AppControlRouteRouteWithChildren,
  AppF29RouteRoute: AppF29RouteRouteWithChildren,
  AppRemuneracionesRouteRoute: AppRemuneracionesRouteRouteWithChildren,
  AppRrhhRouteRoute: AppRrhhRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppCorreoAuditDescarteRoute: AppCorreoAuditDescarteRoute,
  AppDebugSimulateRoute: AppDebugSimulateRoute,
  AppInformesDestinatariosRoute: AppInformesDestinatariosRoute,
  AppTasksBitacoraRoute: AppTasksBitacoraRoute,
  AppVirtualOfficesAutorizacionesRoute: AppVirtualOfficesAutorizacionesRoute,
  AppVirtualOfficesCorrespondenciaRoute: AppVirtualOfficesCorrespondenciaRoute,
  AppVirtualOfficesSucursalesRoute: AppVirtualOfficesSucursalesRoute,
  AppApprovalsIndexRoute: AppApprovalsIndexRoute,
  AppCaptacionIndexRoute: AppCaptacionIndexRoute,
  AppContratosIndexRoute: AppContratosIndexRoute,
  AppCorreoIndexRoute: AppCorreoIndexRoute,
  AppDiagnosticoTributarioIndexRoute: AppDiagnosticoTributarioIndexRoute,
  AppEquipoIndexRoute: AppEquipoIndexRoute,
  AppFacturacionIndexRoute: AppFacturacionIndexRoute,
  AppGestionesIndexRoute: AppGestionesIndexRoute,
  AppInformesIndexRoute: AppInformesIndexRoute,
  AppMessagingIndexRoute: AppMessagingIndexRoute,
  AppProduccionIndexRoute: AppProduccionIndexRoute,
  AppTasksIndexRoute: AppTasksIndexRoute,
  AppVirtualOfficesIndexRoute: AppVirtualOfficesIndexRoute,
  AppCorreoCampaignsIndexRoute: AppCorreoCampaignsIndexRoute,
  AppCorreoLogsIndexRoute: AppCorreoLogsIndexRoute,
  AppCrmAiActionsIndexRoute: AppCrmAiActionsIndexRoute,
  AppCrmCatalogIndexRoute: AppCrmCatalogIndexRoute,
  AppCrmLeadsIndexRoute: AppCrmLeadsIndexRoute,
  AppMessagingCampaignsIndexRoute: AppMessagingCampaignsIndexRoute,
  AppMessagingLogsIndexRoute: AppMessagingLogsIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface PortalRouteChildren {
  PortalDashboardRoute: typeof PortalDashboardRoute
  PortalFacturasRoute: typeof PortalFacturasRoute
  PortalLoginRoute: typeof PortalLoginRoute
  PortalOficinaVirtualRoute: typeof PortalOficinaVirtualRoute
  PortalTributarioRoute: typeof PortalTributarioRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalDashboardRoute: PortalDashboardRoute,
  PortalFacturasRoute: PortalFacturasRoute,
  PortalLoginRoute: PortalLoginRoute,
  PortalOficinaVirtualRoute: PortalOficinaVirtualRoute,
  PortalTributarioRoute: PortalTributarioRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  PortalRoute: PortalRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthMfaChallengeRoute: AuthMfaChallengeRoute,
  AuthMfaEnrollRoute: AuthMfaEnrollRoute,
  PublicRrhhSelfServiceTokenRoute: PublicRrhhSelfServiceTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
